// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .CookiesDisclaimer-cookiesBackground-P4pC2 {
 	background-color: var(--primary-white-bg) !important;
 	border-radius: 4px;
 	-webkit-box-shadow: 0 1px 10px 0px #484848;
 	        box-shadow: 0 1px 10px 0px #484848;
 }

 .CookiesDisclaimer-root-t3opH {
 	padding: 10px;
 }

 .CookiesDisclaimer-labelText-cAfUQ {
 	color: var(--common-text-color) !important;
 	font-size: 16px;
 	font-weight: 400;
 	line-height: normal;
 }

 .CookiesDisclaimer-paddingSpace-Q3gTs {
 	padding-right: 16px;
 	padding-left: 16px;
 }

 .CookiesDisclaimer-linkStyle-USfHQ {
 	color: var(--common-text-color) !important;
 	font-style: italic;
 	font-weight: bold;
 	text-decoration: underline;
 }

 .CookiesDisclaimer-button-sbqg1 {
 	border-color: var(--btn-primary-bg) !important;
 	background-color: var(--btn-primary-bg) !important;
 	color: var(--white-text);
 	font-size: 16px;
 	font-weight: 700;
 	margin-top: 0px;
 	float: right;
 	z-index: 9;
 	border-radius: 60px;
 }

 .CookiesDisclaimer-button-sbqg1:hover,
 .CookiesDisclaimer-button-sbqg1:focus,
 .CookiesDisclaimer-button-sbqg1:active,
 .CookiesDisclaimer-button-sbqg1:active:hover,
 .CookiesDisclaimer-button-sbqg1:active:focus {
 	border-color: var(--btn-primary-bg-hover) !important;
 	background-color: var(--btn-primary-bg-hover) !important;
 	color: var(--white-text) !important;
 }

 .CookiesDisclaimer-fixedPosition-OKfG9 {
 	position: fixed !important;
 	right: 0px;
 	bottom: 0px;
 	left: 0px;
 	z-index: 1005;
 }

 @media screen and (max-width: 480px) {
 	.CookiesDisclaimer-cookiesBackground-P4pC2 {
 		background-color: var(--primary-white-bg) !important;
 		height: auto;
 	}

 	.CookiesDisclaimer-button-sbqg1 {
 		float: right;
 		margin-top: 0px;
 		margin-bottom: 10px;
 		font-size: 15px;
 		font-weight: 300;
 	}

 	.CookiesDisclaimer-labelText-cAfUQ {
 		font-size: 15px;
 	}
 }

 .CookiesDisclaimer-displayTable-s367o {
 	width: 100%;
 	display: table;
 }

 .CookiesDisclaimer-displayRow-pWJj7 {
 	width: 100%;
 	display: table-row;
 }

 .CookiesDisclaimer-displayText-u7vsj {
 	display: table-cell;
 	width: 90%;
 	vertical-align: middle;
 }

 .CookiesDisclaimer-displayBtn-3BQZA {
 	width: 10%;
 	display: table-cell;
 	vertical-align: middle;
 }

 .CookiesDisclaimer-displayTableSection-qKmDt {
 	padding: 15px;
 }

 @media screen and (max-width: 767px) {
 	.CookiesDisclaimer-displayText-u7vsj {
 		display: block;
 		width: 100%;
 		vertical-align: middle;
 	}

 	.CookiesDisclaimer-displayBtn-3BQZA {
 		width: 100%;
 		display: block;
 		vertical-align: middle;
 	}

 	.CookiesDisclaimer-button-sbqg1 {
 		border-color: var(--btn-primary-bg) !important;
 		background-color: var(--btn-primary-bg) !important;
 		color: var(--white-text);
 		font-size: 16px;
 		font-weight: 700;
 		margin-top: 8px;
 		float: right;
 		z-index: 9;
 	}

 	.CookiesDisclaimer-displayTableSection-qKmDt {
 		padding: 15px;
 	}
 }

 @media screen and (max-width: 1030px) {
 	.CookiesDisclaimer-labelText-cAfUQ {
 		color: var(--common-text-color) !important;
 		font-size: 14px;
 		font-weight: 400;
 		line-height: normal;
 	}
 }`, "",{"version":3,"sources":["webpack://./src/components/CookiesDisclaimer/CookiesDisclaimer.css"],"names":[],"mappings":"CAAC;EACC,oDAAoD;EACpD,kBAAkB;EAClB,0CAAkC;UAAlC,kCAAkC;CACnC;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;CAC3B;;CAEA;EACC,8CAA8C;EAC9C,kDAAkD;EAClD,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mBAAmB;CACpB;;CAEA;;;;;EAKC,oDAAoD;EACpD,wDAAwD;EACxD,mCAAmC;CACpC;;CAEA;EACC,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,SAAS;EACT,aAAa;CACd;;CAGA;EACC;GACC,oDAAoD;GACpD,YAAY;EACb;;EAEA;GACC,YAAY;GACZ,eAAe;GACf,mBAAmB;GACnB,eAAe;GACf,gBAAgB;EACjB;;EAEA;GACC,eAAe;EAChB;CACD;;CAEA;EACC,WAAW;EACX,cAAc;CACf;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;EACnB,UAAU;EACV,sBAAsB;CACvB;;CAEA;EACC,UAAU;EACV,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC;GACC,cAAc;GACd,WAAW;GACX,sBAAsB;EACvB;;EAEA;GACC,WAAW;GACX,cAAc;GACd,sBAAsB;EACvB;;EAEA;GACC,8CAA8C;GAC9C,kDAAkD;GAClD,wBAAwB;GACxB,eAAe;GACf,gBAAgB;GAChB,eAAe;GACf,YAAY;GACZ,UAAU;EACX;;EAEA;GACC,aAAa;EACd;CACD;;CAEA;EACC;GACC,0CAA0C;GAC1C,eAAe;GACf,gBAAgB;GAChB,mBAAmB;EACpB;CACD","sourcesContent":[" .cookiesBackground {\n \tbackground-color: var(--primary-white-bg) !important;\n \tborder-radius: 4px;\n \tbox-shadow: 0 1px 10px 0px #484848;\n }\n\n .root {\n \tpadding: 10px;\n }\n\n .labelText {\n \tcolor: var(--common-text-color) !important;\n \tfont-size: 16px;\n \tfont-weight: 400;\n \tline-height: normal;\n }\n\n .paddingSpace {\n \tpadding-right: 16px;\n \tpadding-left: 16px;\n }\n\n .linkStyle {\n \tcolor: var(--common-text-color) !important;\n \tfont-style: italic;\n \tfont-weight: bold;\n \ttext-decoration: underline;\n }\n\n .button {\n \tborder-color: var(--btn-primary-bg) !important;\n \tbackground-color: var(--btn-primary-bg) !important;\n \tcolor: var(--white-text);\n \tfont-size: 16px;\n \tfont-weight: 700;\n \tmargin-top: 0px;\n \tfloat: right;\n \tz-index: 9;\n \tborder-radius: 60px;\n }\n\n .button:hover,\n .button:focus,\n .button:active,\n .button:active:hover,\n .button:active:focus {\n \tborder-color: var(--btn-primary-bg-hover) !important;\n \tbackground-color: var(--btn-primary-bg-hover) !important;\n \tcolor: var(--white-text) !important;\n }\n\n .fixedPosition {\n \tposition: fixed !important;\n \tright: 0px;\n \tbottom: 0px;\n \tleft: 0px;\n \tz-index: 1005;\n }\n\n\n @media screen and (max-width: 480px) {\n \t.cookiesBackground {\n \t\tbackground-color: var(--primary-white-bg) !important;\n \t\theight: auto;\n \t}\n\n \t.button {\n \t\tfloat: right;\n \t\tmargin-top: 0px;\n \t\tmargin-bottom: 10px;\n \t\tfont-size: 15px;\n \t\tfont-weight: 300;\n \t}\n\n \t.labelText {\n \t\tfont-size: 15px;\n \t}\n }\n\n .displayTable {\n \twidth: 100%;\n \tdisplay: table;\n }\n\n .displayRow {\n \twidth: 100%;\n \tdisplay: table-row;\n }\n\n .displayText {\n \tdisplay: table-cell;\n \twidth: 90%;\n \tvertical-align: middle;\n }\n\n .displayBtn {\n \twidth: 10%;\n \tdisplay: table-cell;\n \tvertical-align: middle;\n }\n\n .displayTableSection {\n \tpadding: 15px;\n }\n\n @media screen and (max-width: 767px) {\n \t.displayText {\n \t\tdisplay: block;\n \t\twidth: 100%;\n \t\tvertical-align: middle;\n \t}\n\n \t.displayBtn {\n \t\twidth: 100%;\n \t\tdisplay: block;\n \t\tvertical-align: middle;\n \t}\n\n \t.button {\n \t\tborder-color: var(--btn-primary-bg) !important;\n \t\tbackground-color: var(--btn-primary-bg) !important;\n \t\tcolor: var(--white-text);\n \t\tfont-size: 16px;\n \t\tfont-weight: 700;\n \t\tmargin-top: 8px;\n \t\tfloat: right;\n \t\tz-index: 9;\n \t}\n\n \t.displayTableSection {\n \t\tpadding: 15px;\n \t}\n }\n\n @media screen and (max-width: 1030px) {\n \t.labelText {\n \t\tcolor: var(--common-text-color) !important;\n \t\tfont-size: 14px;\n \t\tfont-weight: 400;\n \t\tline-height: normal;\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cookiesBackground": `CookiesDisclaimer-cookiesBackground-P4pC2`,
	"root": `CookiesDisclaimer-root-t3opH`,
	"labelText": `CookiesDisclaimer-labelText-cAfUQ`,
	"paddingSpace": `CookiesDisclaimer-paddingSpace-Q3gTs`,
	"linkStyle": `CookiesDisclaimer-linkStyle-USfHQ`,
	"button": `CookiesDisclaimer-button-sbqg1`,
	"fixedPosition": `CookiesDisclaimer-fixedPosition-OKfG9`,
	"displayTable": `CookiesDisclaimer-displayTable-s367o`,
	"displayRow": `CookiesDisclaimer-displayRow-pWJj7`,
	"displayText": `CookiesDisclaimer-displayText-u7vsj`,
	"displayBtn": `CookiesDisclaimer-displayBtn-3BQZA`,
	"displayTableSection": `CookiesDisclaimer-displayTableSection-qKmDt`
};
module.exports = ___CSS_LOADER_EXPORT___;
